// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"185":"prototype","213":"textContent","279":"hero","326":"fullMedia","465":"doubleMedia","762":"doubleText","911":"infiniteSlider","999":"overMediaText"}[chunkId] + ".js";
};